import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const Root = styled.div `
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: ${(props) => props.color};
  box-shadow: ${(props) => props.color} 0px 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const IconWithBackground = ({ icon, color, size = 30, ref, ...props }) => (_jsx(Root, { ref: ref, color: color, size: size, ...props, children: icon }));
//# sourceMappingURL=icon-with-background.js.map